export type TApiError = Error & {
  errorCode: TApiErrorCodes
}

export type TApiErrorCodes = keyof typeof RENDER_PROJECT_ERROR_CODE

export enum RENDER_PROJECT_ERROR_CODE {
  MAX_DURATION_EXCEEDED = 'MAX_DURATION_EXCEEDED',
  DURATION_EXCEEDED = 'DURATION_EXCEEDED',
  MAX_QUALITY_EXCEEDED = 'MAX_QUALITY_EXCEEDED',
  MIN_DURATION_EXCEEDED = 'MIN_DURATION_EXCEEDED',
  VIDEO_GENERATION_CONCURRENT_LIMIT_EXCEEDED = 'VIDEO_GENERATION_CONCURRENT_LIMIT_EXCEEDED',
  // Returned (HTTP 422) when a free user in a low-priority country attempts
  // generation while the system is under high load. The request was rejected
  // before any work or credit charge occurred.
  COUNTRY_BLOCKED = 'COUNTRY_BLOCKED'
}

export const upgradePopupErrorCodes = [
  RENDER_PROJECT_ERROR_CODE.DURATION_EXCEEDED,
  RENDER_PROJECT_ERROR_CODE.MAX_QUALITY_EXCEEDED
]

// Backend codes that aren't real failures — they signal a state the user can
// resolve (e.g. enable power mode and retry). The generation never started,
// so failure-cleanup paths (restore item, reselect, reset form) must skip.
export const softErrorCodes = [
  RENDER_PROJECT_ERROR_CODE.VIDEO_GENERATION_CONCURRENT_LIMIT_EXCEEDED,
  RENDER_PROJECT_ERROR_CODE.COUNTRY_BLOCKED
]
